var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayVideo = function SvgPlayVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.671 0h70.866a6.67 6.67 0 0 1 6.671 6.671v47.82A9.51 9.51 0 0 1 74.7 64H9.51A9.51 9.51 0 0 1 0 54.491V6.671A6.67 6.67 0 0 1 6.671 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    d: "M6.671 0h70.866a6.67 6.67 0 0 1 6.671 6.671v.973H0V6.67A6.67 6.67 0 0 1 6.671 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.687 3.822a.996.996 0 1 1-1.992-.002.996.996 0 0 1 1.992.002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.715 4.817a.996.996 0 1 0 0-1.99.996.996 0 0 0 0 1.99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M15.162 4.817a.996.996 0 1 0 0-1.99.996.996 0 0 0 0 1.99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    d: "M8.537 53.999h-4.92v4.92h4.92z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.453,
    d: "M5.47 57.294v-1.682M6.671 57.294v-1.682"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5DBED",
    d: "M77.8 55.257H10.082v2.712H77.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    d: "M38.22 55.257H10.082v2.712H38.22z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCF2EC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    d: "M82.4 15.299V37.36M82.4 10.779v2.197"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#18A87D",
    d: "M47.934 44.333c6.464-2.643 9.561-10.026 6.918-16.49s-10.025-9.56-16.49-6.917c-6.463 2.643-9.56 10.025-6.917 16.49 2.643 6.463 10.026 9.56 16.49 6.917"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.284 37.51v-9.75l9.12 3.982z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00D9A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    d: "M34.134 27.303c1.51-3.41 5.298-5.653 9.006-5.344"
  })));
};
export default SvgPlayVideo;